import momentTZ from 'moment-timezone'
import moment, { Moment } from 'moment';

export const convertDateToLocal = (date: string | number | undefined | Moment) => 
    momentTZ.tz((moment.utc(date)), 'Israel');